import { render } from "./LicenseSettings.vue?vue&type=template&id=bd686428&scoped=true"
import script from "./LicenseSettings.vue?vue&type=script&lang=js"
export * from "./LicenseSettings.vue?vue&type=script&lang=js"

import "./LicenseSettings.vue?vue&type=style&index=0&id=bd686428&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd686428"]])

export default __exports__